import { createSwiper } from '@nulo/swiper';

const DESKTOP_MQ = window.matchMedia('(min-width: 1024px)');

/**
 * @extends {HTMLElement}
 */
class BlogCategoryRows extends HTMLElement {
  /** @type {import('swiper').Swiper[]} */
  #swipers = [];

  /** @type {(() => void) | null} */
  #mqListener = null;

  connectedCallback() {
    this.#mqListener = () => this.#syncSwipers();
    DESKTOP_MQ.addEventListener('change', this.#mqListener);
    this.#syncSwipers();
  }

  disconnectedCallback() {
    this.#destroySwipers();
    if (this.#mqListener) {
      DESKTOP_MQ.removeEventListener('change', this.#mqListener);
      this.#mqListener = null;
    }
  }

  #syncSwipers() {
    this.#destroySwipers();
    if (DESKTOP_MQ.matches) return;

    for (const region of this.querySelectorAll('[data-category-row-carousel]')) {
      if (!(region instanceof HTMLElement)) continue;

      const swiperEl = region.querySelector('[data-swiper]');
      if (!(swiperEl instanceof HTMLElement)) continue;

      const swiper = createSwiper({
        region,
        el: swiperEl,
        activeSlideClass: 'swiper-slide-active',
        config: {
          slidesPerView: 1.4,
          spaceBetween: 20,
          navigation: {
            nextEl: region.querySelector('.blog-category-row__nav--next'),
            prevEl: region.querySelector('.blog-category-row__nav--prev'),
          },
          breakpoints: {
            300: {
              slidesPerView: 1.4,
              spaceBetween: 20,
            },
            400: {
              slidesPerView: 1.7,
              spaceBetween: 18,
            },
            576: {
              slidesPerView: 2.5,
              spaceBetween: 18,
            },
            768: {
              slidesPerView: 3.5,
              spaceBetween: 20,
            },
          },
        },
      });

      if (swiper) this.#swipers.push(swiper);
    }
  }

  #destroySwipers() {
    for (const swiper of this.#swipers) {
      swiper?.destroy?.(true, true);
    }
    this.#swipers = [];
  }
}

if (!customElements.get('blog-category-rows')) {
  customElements.define('blog-category-rows', BlogCategoryRows);
}
